import { AMOBILE_BANK_ID } from '@/entities/banks'
import { ConversionBlock } from '@/entities/conversion'
import { PaymentRequisitIcon } from '@/entities/paymentRequisit'
import EditIcon from '@/shared/assets/icons/edit.svg?react'
import { BaseButton, BaseCard, BaseCheckbox } from '@/shared/components'
import { BaseProgressBar } from '@/shared/components/BaseProgressBar/BaseProgressBar'
import { BankIcon } from '@/shared/components/icons/banks/BankIcon'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { formatCardNumber, formatPhoneNumber } from '../../model'
import { EnrichedRequisitesModel } from '../../statistic'
import { formatterRubWithCurrency } from '@/shared/utils'

type Props = {
  requisit: EnrichedRequisitesModel
  isSelected: boolean
  onSelect: (selected: boolean) => void
  onEdit?: (id: string) => void
}

export const RequisiteMobileBlock = ({ requisit, isSelected, onSelect, onEdit }: Props) => {
  const paymentRequisit =
    requisit?.bankId === AMOBILE_BANK_ID
      ? formatPhoneNumber(requisit?.paymentRequisitProfiles?.[0]?.value ?? '').formatted
      : formatCardNumber(requisit?.paymentRequisitProfiles?.[0]?.value ?? '').formatted

  // Суммы из dailyStats
  const totalAmountRub = requisit.dailyStats?.reduce((sum, s) => sum + s.amountInRub, 0) ?? 0
  const totalIn = requisit.totalStats?.reduce((sum, s) => sum + s.counterIn, 0) ?? 0
  const totalSuccess = requisit.totalStats?.reduce((sum, s) => sum + s.counterInSuccess, 0) ?? 0
  const amountInRub = requisit.totalStats?.reduce((sum, s) => sum + s.amountInRub, 0) ?? 0

  return (
    <div className="md:hidden mb-4 last:mb-0 w-full">
      <Link to={`${requisit.id}`} className="w-full no-underline">
        <BaseCard className="px-5 text-sm">
          <div className="pb-6">
            <BaseCheckbox checked={isSelected} onChange={onSelect} />
          </div>
          <div className="flex justify-between pb-4">
            <div className="flex gap-3">
              <BankIcon
                bankId={requisit.bankId}
                status={
                  requisit.isBlocked
                    ? 'stopped'
                    : requisit.isDeleted
                      ? 'canceled'
                      : requisit.isDisabledByUser
                        ? 'stopped'
                        : 'active'
                }
              />
              <div className="flex flex-col">
                <span className="font-medium">{`${requisit.personSurname ?? ''} ${requisit.personName ?? ''} ${requisit.personMiddlename ?? ''}`}</span>
                <span className="text-text-secondary text-sm">{paymentRequisit}</span>
              </div>
            </div>
            <div className="flex items-center gap-6">
              <BaseButton
                variant="ghost"
                size="icon"
                onClick={(event) => {
                  event.stopPropagation()
                  event.preventDefault()
                  onEdit?.(requisit.id)
                }}
              >
                <EditIcon className="text-text-secondary" />
              </BaseButton>
            </div>
          </div>

          <div className="flex flex-col gap-y-2 pb-4 w-full">
            <span className="text-text-secondary">Суточный лимит</span>
            <BaseProgressBar
              variant="full"
              currentBalance={totalAmountRub}
              totalBalance={requisit.maxDailyLimit ?? 0}
            />
          </div>
          <div className="flex flex-col gap-y-2 pb-4">
            <span className="text-text-secondary">Общий оборот</span>
            <span className="">{formatterRubWithCurrency.format(amountInRub)}</span>
          </div>
          <div className="flex flex-col gap-y-2 pb-4">
            <span className="text-text-secondary">Конверсия</span>
            <ConversionBlock current={totalSuccess} goal={totalIn} />
          </div>

          <div className="flex flex-col gap-y-2">
            <span className="text-text-secondary">Активные</span>
            <div className="flex flex-wrap items-center gap-2">
              {requisit.paymentRequisitProfiles?.map((account) => (
                <div
                  key={account.id}
                  className={clsx(
                    'flex items-center gap-1 px-2 border border-card-border dark:border-card-border-dark rounded-lg',
                    {
                      'bg-[var(--status-green-fill)]':
                        !account.isBlocked && !account.isDisabledByUser,
                      'bg-[var(--status-grey-fill)]': account.isBlocked || account.isDisabledByUser,
                    }
                  )}
                >
                  <PaymentRequisitIcon
                    className="w-4"
                    accountType={account.requisitType}
                    status={!(account.isDisabledByUser || account.isBlocked) ? 1 : 40}
                  />
                  <span
                    className={clsx('text-xs', {
                      'text-text-verificated': !account.isBlocked && !account.isDisabledByUser,
                      'text-text-secondary': account.isBlocked || account.isDisabledByUser,
                    })}
                  >{`... ${account.value.slice(-4)}`}</span>
                </div>
              ))}
            </div>
          </div>
        </BaseCard>
      </Link>
    </div>
  )
}
